import React, { useEffect, useState } from 'react'
import { Btn, CustomModal, InputNumeroDecimal } from '../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import MovimentacaoLastMileHttp from '../../../../services/api/https/patrimonio/movimentacao-last-mile.http'
import { errorHandler } from '../../../../services/util/error.service'

export default function ModalApuracaoFisica({
  visible,
  onResponse,
  selectedPrestacaoContas,
  ativos,
}) {
  const [isLoading, setIsLoading] = useState(false)
  const [listAtivo, setListaAtivo] = useState([])

  useEffect(() => {
    if (selectedPrestacaoContas && selectedPrestacaoContas.ativos.length > 0) {
      const novaLista = []
      ativos.forEach(a => {
        const ativo = selectedPrestacaoContas.ativos.find(
          sa => sa.patrimonio_ativo_id === a.ativo_id,
        )
        if (ativo) {
          novaLista.push({ ...a, qte_prestacao_contas: ativo.qte })
        } else {
          novaLista.push({ ...a, qte_prestacao_contas: '' })
        }
      })
      setListaAtivo([...novaLista])
    } else {
      setListaAtivo(ativos.map(at => ({ ...at, qte_prestacao_contas: '' })))
    }
  }, [visible])

  // Events
  const onQuantidadeChange = (ativo, value) => {
    setListaAtivo(prevState => {
      const index = prevState.findIndex(p => p.ativo_id === ativo.ativo_id)
      if (index !== -1) {
        prevState[index].qte_prestacao_contas = value
      }
      return [...prevState]
    })
  }
  const onBtnSalvarClick = () => {
    const items = listAtivo.map(a => ({
      prestacao_contas_id: selectedPrestacaoContas.id,
      patrimonio_ativo_id: a.ativo_id,
      qte: Number.isNaN(a.qte_prestacao_contas) ? 0 : Number(a.qte_prestacao_contas),
    }))
    setIsLoading(true)
    MovimentacaoLastMileHttp.saveApuracaoFisica(items)
      .then(savedItems => {
        selectedPrestacaoContas.ativos = savedItems
        onResponse('success', { ...selectedPrestacaoContas })
      })
      .catch(error => {
        onResponse('error', errorHandler(error))
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  // Render
  return (
    <CustomModal
      width={600}
      isVisible={visible}
      onClose={() => onResponse('close')}
      header={'Apuração Física'}
    >
      <div className="p-grid">
        <div className="p-col-12">
          <Btn isLoading={isLoading} onClick={onBtnSalvarClick}>
            Salvar
          </Btn>
        </div>
        <div className="p-col-12">
          <DataTable loading={isLoading} value={listAtivo} paginator={true} rows={5}>
            <Column field={'ativo_name'} header={'Ativo Patrimonial'} />
            <Column
              field={'qte_prestacao_contas'}
              header={'Prestação Contas'}
              body={ativo => (
                <InputNumeroDecimal
                  value={ativo.qte_prestacao_contas}
                  onChange={value => onQuantidadeChange(ativo, value)}
                  marginTop={0}
                />
              )}
              style={tableCellCentered(150)}
            />
          </DataTable>
        </div>
      </div>
    </CustomModal>
  )
}
